import { ChangeEvent } from "react";
import {
  Brand,
  CategoryAdminDTO,
  ProductMetaDTO,
  SubCategoryAdminRequestDTO
} from "Types";
import { PLANT } from "Constants";
import { useGetAllAdminProductsQuery, useGetAllBrandsQuery, useGetAllCategoriesQuery, useGetAllSubCategoriesQuery } from "Services/Admin";






interface ActionsProps {
  onFilterChange: (name: string, value: string) => void;
  mode?: string;
  formData: {
    category: string;
    subCategory: string;
    brand: string;
    productName?: string;
  };
}

export const SectionProductActions = ({
  onFilterChange,
  mode,
  formData,
}: ActionsProps) => {
  const { data: apiCategories, isLoading: isLoadingCategories } =
    useGetAllCategoriesQuery();
  const { data: apiSubCategories, isLoading: isLoadingSubCategories } =
    useGetAllSubCategoriesQuery();
  const { data: apiBrands, isLoading: isLoadingBrands } = useGetAllBrandsQuery({
    plant: PLANT,
  });
  const { data: productsData, isLoading: isLoadingProducts } =
    useGetAllAdminProductsQuery({
      category: formData.category || "",
      subCategory: formData.subCategory || "",
      brand: formData.brand || "",
      activePage: 1,
      pageSize: 1000,
    });

  const categories: CategoryAdminDTO[] = apiCategories || [];
  const subCategories: SubCategoryAdminRequestDTO[] = apiSubCategories || [];
  const brands: Brand[] = apiBrands || [];
  const products: ProductMetaDTO[] = productsData?.products || [];

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    onFilterChange(name, value);
  };

  return (
    <>
      <div className="font-body tracking-wider grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 gap-y-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-500 mb-1">
            Product Name
          </label>
          <input
            type="text"
            name="productName"
            className="w-full px-3 py-2 border rounded-md text-sm border-gray-300 focus:outline-none focus:ring-0"
            disabled={mode === "view"}
            value={formData.productName || ""}
            onChange={handleChange}
            placeholder="Search by product name..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-500 mb-1">
            Category
          </label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-md text-sm"
            disabled={mode === "view" || isLoadingCategories}
          >
            <option value="">Select a Category</option>
            {categories.map((category) => (
              <option key={category.categoryCode} value={category.categoryCode}>
                {category.categoryName}
              </option>
            ))}
          </select>
          {isLoadingCategories && (
             <div className="flex items-center justify-center min-h-[200px]">
    <div className="w-8 h-8 border-4 border-orange-400 border-t-transparent rounded-full animate-spin"></div>
  </div>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-500 mb-1">
            Sub Category
          </label>
          <select
            name="subCategory"
            value={formData.subCategory}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-md text-sm"
            disabled={mode === "view" || isLoadingSubCategories}
          >
            <option value="">Select a Sub Category</option>
            {subCategories.map((subCategory) => (
              <option
                key={subCategory.subCategoryCode}
                value={subCategory.subCategoryCode}
              >
                {subCategory.subCategoryName}
              </option>
            ))}
          </select>
          {isLoadingSubCategories && (
            <div className="flex items-center justify-center min-h-[60vh]">
      <div className="w-10 h-10 border-4 border-orange-400 border-t-transparent rounded-full animate-spin"></div>
    </div>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-500 mb-1">
            Brand
          </label>
          <select
            name="brand"
            value={formData.brand || ""}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-md text-sm"
            disabled={mode === "view" || isLoadingBrands}
          >
            <option value="">Select a Brand</option>
            {brands.map((brand, index) => (
              <option key={brand.id || index} value={brand.id}>
                {brand.productBrandDesc}
              </option>
            ))}
          </select>
          {isLoadingBrands && (
            <p className="text-sm text-gray-500 mt-1">Loading Brands...</p>
          )}
        </div>
      </div>
    </>
  );
};
